import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  inbound_items_forms: [],
};

const getters = {
  allInboundItemsForms: (state) => state.inbound_items_forms,
};

const actions = {
  async fetchInboundItemsForms({ commit }, params = {}) {
    try {
      commit("resetInboundItemsForms");
      const response = await axios.get("/inbound-items-form", { params: prm(params) });
      commit("setInboundItemsForms", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch inbound_items_forms:", error);
    }
  },
  async createInboundItemsForm({ commit }, inbound_items_form) {
    try {
      const response = await axios.post("/inbound-items-form", inbound_items_form);
      commit("addInboundItemsForm", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create inbound_items_form:", error);
      throw error;
    }
  },
  async fetchInboundItemsFormById(_, id) {
    try {
      const response = await axios.get(`/inbound-items-form/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch inbound_items_form:", error);
      throw error;
    }
  },
  async updateInboundItemsForm({ commit }, inbound_items_form) {
    try {
      const response = await axios.put(`/inbound-items-form/${inbound_items_form.id}`, inbound_items_form);
      commit("updateInboundItemsForm", response.data);
    } catch (error) {
      console.error("Failed to update inbound_items_form:", error);
      throw error;
    }
  },
  async closeInboundItemsForm({ commit }, inbound_items_form) {
    try {
      const response = await axios.post(`/inbound-items-form/close`, inbound_items_form);
      commit("closeInboundItemsForm", response.data);
    } catch (error) {
      console.error("Failed to close inbound_items_form:", error);
      throw error;
    }
  },
  async deleteInboundItemsFormById({ commit }, id) {
    try {
      const response = await axios.delete(`/inbound-items-form/${id}`);
      commit("removeInboundItemsForm", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete inbound_items_form:", error);
      throw error;
    }
  },
};

const mutations = {
  setInboundItemsForms(state, inbound_items_forms) {
    state.inbound_items_forms = inbound_items_forms.data; // Ensure this matches your API's response structure
  },
  addInboundItemsForm(state, inbound_items_form) {
    state.inbound_items_forms.push(inbound_items_form);
  },
  updateInboundItemsForm(state, updatedInboundItemsForm) {
    const index = state.inbound_items_forms.findIndex(
      (inbound_items_form) => inbound_items_form.id === updatedInboundItemsForm.id
    );
    if (index !== -1) {
      state.inbound_items_forms.splice(index, 1, updatedInboundItemsForm);
    }
  },
  removeInboundItemsForm(state, id) {
    state.inbound_items_forms = state.inbound_items_forms.filter(
      (inbound_items_form) => inbound_items_form.id !== id
    );
  },
  resetInboundItemsForms(state) {
    state.inbound_items_forms = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
